type RectLike = Pick<DOMRect, 'height' | 'left' | 'top' | 'width'>

export function getPointerPositionPercent(clientX: number, clientY: number, rect: RectLike) {
  const x = rect.width > 0 ? ((clientX - rect.left) / rect.width) * 100 : 0
  const y = rect.height > 0 ? ((clientY - rect.top) / rect.height) * 100 : 0

  return {
    x: Math.min(100, Math.max(0, x)),
    y: Math.min(100, Math.max(0, y)),
  }
}

export function lerp(start: number, end: number, factor: number) {
  return start + (end - start) * factor
}
